import AdminCategorie from "./AdminCategorie";

export default AdminCategorie;
